<template>
  <div class="agent-toggle">
    <AgentsList :total="getTotal" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AgentsList from "@/views/call-center/orders/list/tab/view/agent/list";

export default {
  name: "AgentOrdersList",
  components: { AgentsList },
  data() {
    return {
      option: 0,
      key: 1,
    };
  },

  computed: {
    ...mapGetters({
      filter: "App/filter",
      orders: "Orders/orders",
      ordersCount: "Orders/OrdersCount",
    }),

    getTotal() {
      return this.ordersCount;
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .count-badge {
    background-color: #a6f5ff !important;
    margin: 0 0.7rem;
    padding: 0.2rem 0.5rem;
    line-height: 1.5rem;
    font-weight: 400;

    &:empty {
      display: none;
    }
  }

  .v-btn:not(.v-btn--text):not(.v-btn--outlined):before {
    opacity: 1 !important;
    color: #ffffff !important;

    //background: #edf1f7 !important;
  }

  .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-item--active {
    border-bottom: 0.2rem solid #40c4ff !important;
  }
}
</style>
